var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52154 3.61003C6.17296 2.44144 6.49867 1.85715 6.98563 1.85715C7.47259 1.85715 7.7983 2.44144 8.44972 3.61003L8.61825 3.91235C8.80336 4.24443 8.89592 4.41047 9.04023 4.52002C9.18455 4.62957 9.36428 4.67024 9.72375 4.75157L10.051 4.82562C11.316 5.11183 11.9485 5.25494 12.099 5.73884C12.2494 6.22273 11.8182 6.72695 10.9559 7.73539L10.7328 7.99629C10.4877 8.28286 10.3652 8.42614 10.31 8.6034C10.2549 8.78066 10.2734 8.97183 10.3105 9.35417L10.3442 9.70226C10.4746 11.0477 10.5398 11.7205 10.1458 12.0195C9.75188 12.3186 9.15968 12.0459 7.97528 11.5006L7.66887 11.3595C7.3323 11.2046 7.16401 11.1271 6.98563 11.1271C6.80725 11.1271 6.63896 11.2046 6.30239 11.3595L5.99598 11.5006C4.81158 12.0459 4.21938 12.3186 3.82542 12.0195C3.43146 11.7205 3.49665 11.0477 3.62703 9.70227L3.66077 9.35418C3.69782 8.97183 3.71634 8.78066 3.66122 8.6034C3.60609 8.42614 3.48356 8.28286 3.2385 7.99629L3.01539 7.73539C2.15302 6.72695 1.72183 6.22273 1.8723 5.73884C2.02278 5.25494 2.65527 5.11183 3.92025 4.82562L4.24751 4.75157C4.60698 4.67024 4.78672 4.62957 4.93103 4.52002C5.07534 4.41047 5.1679 4.24443 5.35301 3.91235L5.52154 3.61003Z",
    fill: "#E6B532",
    stroke: "#E6B532",
    strokeWidth: 0.942857
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.33a3ff929b23ec9b36d28e13e5d76bdc.svg";
export { ForwardRef as ReactComponent };